module.exports = __webpack_public_path__ + "img/fuwubaoz_5.eeafb4a0.png";